import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ConnectWithUs from "./sections/ConnectWithUs";
import MediaNewsroom from "./sections/MediaNewsroom";
import FooterInformation from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <ConnectWithUs />
      <MediaNewsroom />
      <FooterInformation />
    </div>;
}